/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_DashboardsInputs */

const en_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboards`)
};

const ar_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحات التحكم`)
};

const bn_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ড্যাশবোর্ড`)
};

const de_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboards`)
};

const es_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paneles de control`)
};

const fr_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableaux de bord`)
};

const pt_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painéis`)
};

const zh_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看板`)
};

const tr_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrol Panelleri`)
};

const ru_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панели мониторинга`)
};

const pl_svchip_dashboards = /** @type {(inputs: Svchip_DashboardsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panele kontrolne`)
};

/**
* | output |
* | --- |
* | "Dashboards" |
*
* @param {Svchip_DashboardsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_dashboards = /** @type {((inputs?: Svchip_DashboardsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_DashboardsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_dashboards(inputs)
	if (locale === "bn") return bn_svchip_dashboards(inputs)
	if (locale === "de") return de_svchip_dashboards(inputs)
	if (locale === "es") return es_svchip_dashboards(inputs)
	if (locale === "fr") return fr_svchip_dashboards(inputs)
	if (locale === "pt") return pt_svchip_dashboards(inputs)
	if (locale === "zh") return zh_svchip_dashboards(inputs)
	if (locale === "tr") return tr_svchip_dashboards(inputs)
	if (locale === "ru") return ru_svchip_dashboards(inputs)
	if (locale === "pl") return pl_svchip_dashboards(inputs)
	return en_svchip_dashboards(inputs)
});